module.exports = __webpack_public_path__ + "img/dannielle.53ec7b35.jpeg";